import React from 'react';
import { Circle, SemiCircle, LineCircle } from './styles';

const HalfCircle = props => (
  <div {...props} style={{ position: 'relative' }}>
    <SemiCircle style={{ position: 'absolute', top: '-0.5em' }} />
    <LineCircle style={{ position: 'absolute', top: '-0.5em' }} />
  </div>
);

const iconMap = {
  scenario: <Circle title="Scenario Item" />,
  linked: <HalfCircle title="Linked Item" />,
  active: <LineCircle title="Active Item" />,
};

// If for some reason no type is return, make sure return blank cell instead of
// breaking the app.
const LinkIcon = ({ type }) => type ? iconMap[type] : '';

export default LinkIcon;
